// extracted by mini-css-extract-plugin
export default {"content":"aTdMWM","title":"hxY0hg","topTarget":"PQ9Tst"};